import upperFirst from 'lodash/upperFirst'

export default {
  data () {
    return {
      errors: [],
    }
  },

  computed: {
    errorsByField () {
      const errors = {}

      const normalizeFieldName = (fieldName) => {
        return upperFirst(fieldName.replace('_id', ''))
      }

      this.errors.forEach((error) => {
        // @TODO: Run these through i18n.
        errors[error.field] = `${normalizeFieldName(error.field)} ${error.message.toLowerCase()}.`
      })

      return errors
    },
  },

  methods: {
    clearErrors () {
      this.errors = []
    },

    async handleException (e) {
      if (e.name === 'ValidationException') {
        this.errors = await e.errors()
        this.$notify('error', this.$t('ensure_input_is_correct'))
      } else {
        this.$notify('error', this.$t('something_unexpected_occurred'))
      }
    },
  },
}
